import {AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges,} from "@angular/core";
import {ContentItemService} from "../../../../service/services/rest/content-item/content-item.service";
import {FolderService} from "../../../../service/services/rest/folder/folder.service";
import {ResourceGroupService} from "../../../../service/services/rest/resource-group/resource-group.service";
import {ResourceDataService} from "../../../../service/services/rest/resource-data/resource-data.service";
import {FileUploadService} from "../../../../service/services/misc/file-upload/file-upload.service";
import {NotificationsService} from "../../../../service/services/misc/notifications/notifications.service";
import {Const, PolicyAction, ResourceState, ResourceType} from "../../../../core/helpers/Const";
import {ResourceModel} from "../../../../core/models/resources/resource.model";
import {Utils} from "../../../../core/helpers/Utils";
import {AbstractContentComponent} from "../../../../core/components/abstract/abstract-content/abstract-content.component";
import {DialogService} from "../../../../service/services/misc/dialog/dialog.service";
import {CreateFolderDialogComponent} from "../../dialogs/create-folder-dialog/create-folder-dialog.component";
import {
    CreateResourceGroupDialogComponent
} from "../../dialogs/create-resource-group-dialog/create-resource-group-dialog.component";
import {
    DeleteConfirmationDialogComponent
} from "../../dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component";
import {MoveResourceDialogComponent} from "../../dialogs/move-resource-dialog/move-resource-dialog.component";
import {OrganizationService} from "../../../../service/services/rest/organization/organization.service";
import {ResourceContentService} from "../../../../service/services/rest/content/resource-content.service";
import {
    TablePersonalizationService
} from "../../../../service/services/misc/table-personalization/table-personalization.service";
import {
    OrganizationHierarchyStoreService
} from "../../../../service/store/organization-hierarchy-store/organization-hierarchy-store.service";
import {firstValueFrom, forkJoin, Observable, shareReplay, switchMap, takeUntil} from "rxjs";
import {SwaService} from "../../../../service/services/misc/swa/swa.service";
import {FilterOnSearchPipe} from "../../../../shared/pipes/filter-on-search/filter-on-search.pipe";
import {
    CreateGenericResourceDialogComponent
} from "../../dialogs/create-generic-resource-dialog/create-generic-resource-dialog.component";
import {CreateInstanceDialogComponent} from "../../dialogs/create-instance-dialog/create-instance-dialog.component";
import {FetchResponse, Pool, PollingService} from "../../../../service/services/misc/polling";
import {AppConfigService} from "../../../../service/services/misc/app-config/app-config.service";
import {SessionProviderService} from "../../../../service/services/misc/session-provider/session-provider.service";
import {EventService} from "../../../../service/services/misc/event/event.service";
import {UisService} from "../../../../service/services/misc/uis/uis.service";
import {RuleModel} from "../../../../core/models/misc/rule.model";
import {ActivatedRoute, Router} from "@angular/router";
import {
    MoveResourceStatueDialogComponent
} from "../../dialogs/move-resource-status-dialog/move-resource-status-dialog.component";
import {
    MoveResourceConfirmationDialogComponent
} from "../../dialogs/move-resource-confirmation-dialog/move-resource-confirmation-dialog.component";
import {
    MoveFailedErrorMessageDialogComponent
} from "../../dialogs/move-failed-error-message-dialog/move-failed-error-message-dialog.component";
import {
    DeleteFolderWithDataDialogComponent
} from "../../dialogs/delete-folder-with-data-dialog/delete-folder-with-data-dialog.component";
import {
    HasResourcesDeletionFailedDialogComponent
} from "../../dialogs/has-resources-deletion-failed-dialog/has-resources-deletion-failed-dialog.component";
import {
    ResourceHasContentComponent
} from "../../dialogs/resource-has-content-dialog/resource-has-content-dialog.component";
import { GVTModel } from '../../../../core/models/misc/references.model';
import {
    ReconcileFailedErrorMessageDialogComponent
} from "../../dialogs/reconcile-failed-error-message-dialog/reconcile-failed-error-message-dialog.component";
import {AdvancedSearchFilters} from "../../../../shared/components/advanced-search/advanced-search.component";
import {TablePersonalizationDefinitions} from "../../../../core/helpers/TablePersonalizationDefinitions";
import {AiAssistantService} from "../../../../service/services/misc/ai-assistant/ai-assistant.service";

@Component({
    selector: 'app-resource-content',
    templateUrl: './resource-content.component.html',
    styleUrls: ['./resource-content.component.scss'],
    standalone: false
})
export class ResourceContentComponent extends AbstractContentComponent implements AfterViewInit, OnChanges {
    error: Error | null;
    ResourceType = ResourceType;
    Object = Object;
    Utils = Utils;
    NO_VALUE_LABEL = Const.NO_VALUE_LABEL;
    MAX_POLLING_NO_STATUS = 5;
    containerIsMoving = false;
    private readonly pool: Pool;
    ResourceState = ResourceState;
    RESOURCE_MOVING_IN_PROCESS = Const.RESOURCE_MOVING_IN_PROCESS;
    PENDING_DELETION = Const.PENDING_DELETION;

	@Input() currentType: ResourceType;
	@Input() searchTerm: string;
	@Input() override noDataMessage: string;
	@Input() noDataFilteredMessage: string;
	@Input() currentPath: string;
	@Input() fullPath: string;
	@Input() organizationName: string;
	@Input() systemResourcesByGroup: any[] = [];
	@Input() isExpanded: false;
	@Input() override advancedSearchOpen = false;
	@Input() availableResourceTypes: any[] = [];
	@Input() currentFilterViewName: string = 'Standard';
	@Output() errorEvent: EventEmitter<Error> = new EventEmitter<Error>();
	@Output() resourceContentIsMoving: EventEmitter<string> = new EventEmitter<string>();
  @Output() publish: EventEmitter<ResourceModel> = new EventEmitter<ResourceModel>();
  @Output() advancedSearchToggled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() viewSaved: EventEmitter<string> = new EventEmitter<string>();
  @Output() filtersChanged = new EventEmitter<void>();
  filterPipe = FilterOnSearchPipe;
  policiesMap: { [gt: string] : RuleModel[]; } = {};
  override cantDeleteFolderWithContentMsg = "You can't delete this folder because it contains content that wasn't generated using our app setup quick-start wizard.<br><br>" +
	  "To delete this folder, you'll need to empty it manually. If there are nested folders and resource groups, we recommend that you start with the deepest ones and work your way back up to this folder.";
  override cantDeleteRGWithContentMsg = "The resource group you're trying to delete is not empty.  \n" +
	  "<br><br>" +
	  "Please manually delete the content inside the resource group before you can delete the resource group itself.";
  constructor(
	  private _contentItemService: ContentItemService,
	  public _folderService: FolderService,
	  private _resourceGroupService: ResourceGroupService,
	  private _organizationService: OrganizationService,
	  private _organizationHierarchyStore: OrganizationHierarchyStoreService,
	  private resourceDataService: ResourceDataService,
	  private fileUploadService: FileUploadService,
	  private notificationsService: NotificationsService,
	  private tablePersonalizationService: TablePersonalizationService,
	  private organizationHierarchyStore: OrganizationHierarchyStoreService,
	  private sessionProvider: SessionProviderService,
	  protected override _dialogService: DialogService,
	  protected override swaService: SwaService,
	  protected pollingService: PollingService,
	  protected override appConfigService: AppConfigService,
	  protected override router: Router,
	  private route: ActivatedRoute,

    private eventService: EventService,
		protected override uisService: UisService,
		private _aiAssistantService: AiAssistantService
  ) {
	  	super(fileUploadService, notificationsService, _dialogService, tablePersonalizationService, swaService, appConfigService, uisService, router);
		  this.pollingService = pollingService;
		  this.pool = pollingService.getOrBuildPool({ id: 'resource-content', poolingInterval: 4000 });
		  this.sortProperty = 'type';

		  // Start with regular table personalization
		  this.switchTablePersonalization(TablePersonalizationDefinitions.ResourcesTable.key);
		  this.subscribeToNavigationStart();
  }

  ngAfterViewInit() {
	  this.initDatatablePersistency(this.fullPath);
  }

  async ngOnChanges(changes: SimpleChanges) {
	    if (changes['fullPath']?.currentValue) {
          this.pool.clearTasks();
          	await this.loadContent();
	    }

	    if (changes['advancedSearchOpen']) {
	        const isOpen = changes['advancedSearchOpen'].currentValue;

	        if (isOpen && !changes['advancedSearchOpen'].previousValue) {
	            this.pool.clearTasks();
	            this.handleAdvancedSearchOpened();
	        } else if (!isOpen && changes['advancedSearchOpen'].previousValue) {
	            this.handleAdvancedSearchClosed();
	        }
	    }
  }

  protected override handleAdvancedSearchClosed() {
      super.handleAdvancedSearchClosed();
      // Restart polling for resources that need it after items are restored
      setTimeout(() => {
          this.items.forEach(resource => {
              if (this.isResourceInProcess(resource.state)) {
                  this.pollWhileInProcess(resource);
              }
              if (Utils.hasFeatureFlag(Const.FEATURE_MOVE_RESOURCE) && resource.moveInProcess) {
                  this.pollWhileMoving(resource);
              }
          });
      });
  }

  onAdvancedSearchToggled(isOpen: boolean) {
      this.advancedSearchOpen = isOpen;
      if (isOpen) {
          this.savedItems = [...this.items];
          this.items = [];
      } else {
          this.items = [...this.savedItems];
          this.savedItems = [];
      }
  }

  async loadContent() {
      this.forkReqSubject.next(1);
      const items = await firstValueFrom(this.loadItems());
	  //Create a list of uniq GVTModel from items
	  const uniqGVTList = this.getUniqueGVTModels(items);

      const policiesObservable = this.loadPolicies(uniqGVTList);
	  this.containerIsMoving = false;
	  await this.setQueryUid();
      this.policiesLoading = true;
      policiesObservable.subscribe((policiesResult) => {
		  this.onContentReady(policiesResult);

		  this.policiesLoading = false;

		  const resource = this.items.find(resource => resource.uid === this.queryUid);
		  if (resource) {
			  this.queryUid = undefined;
			  this.openRTDResources(resource);
			  this.removeParamsQuery();
		  }

	  });
  }

  async loadFilteredContent(filters: any) {
      // Cancel any previous search
      if (this.searchSubscription) {
          this.searchSubscription.unsubscribe();
          this.searchSubscription = null;
      }

      this.forkReqSubject.next(1);
      super.closeFcl();
      this.setLoading(true);

      // Compose the entire resource → policy sequence into one subscription
      // so cancellation covers both the filtered-resource request AND policy enrichment
      this.searchSubscription = this.resourceDataService.getFilteredResources(filters).pipe(
          switchMap(async (items) => {
              // Create a list of unique GVTModel from items
              const uniqGVTList = this.getUniqueGVTModels(items);
              this.containerIsMoving = false;
              await this.setQueryUid();
              this.policiesLoading = true;

              // Return both items and policies as a tuple
              return {
                  items,
                  policies: await firstValueFrom(this.loadPolicies(uniqGVTList))
              };
          }),
          takeUntil(this.forkReqSubject)
      ).subscribe({
          next: (result) => {
              this.onGetListSuccess(result.items);
              this.onContentReady(result.policies);
              this.policiesLoading = false;

              const resource = this.items.find(resource => resource.uid === this.queryUid);
              if (resource) {
                  this.queryUid = undefined;
                  this.openRTDResources(resource);
                  this.removeParamsQuery();
              }
              this.setLoading(false);
              this.searchSubscription = null;
          },
          error: (err: any) => {
              this.onGetListError(err);
              this.setLoading(false);
              this.policiesLoading = false;
              this.searchSubscription = null;
          }
      });
  }

  private getUniqueGVTModels(items: ResourceModel[]): GVTModel[] {
      // Step 1: Flatten all GVTModels from items and their children
      const allGVTModels = items.flatMap(item => this.extractGVTModels(item));

      // Step 2: Remove duplicates using a Set
      return Array.from(
          new Set(allGVTModels.map(model => JSON.stringify(model)))
      ).map(str => JSON.parse(str));
  }

  // Helper function to extract GVTModels from an item and its children
	@Input() advancedSearchTerms!: any;
	private extractGVTModels(item: ResourceModel): GVTModel[] {
	  let gvtList: GVTModel[] = [
		  new GVTModel({ group: item.apiVersion.split('/')[0], type: "*/*" })
	  ];

	  if (item.resource?.metadata?.mixedInto) {
		  const mixedIntoType = item.resource.metadata.mixedInto.type;
		  const mixedIntoGroup = item.resource.metadata.mixedInto.apiVersion.split('/')[0];
		  gvtList.push(new GVTModel({ group: item.apiVersion.split('/')[0], type: item.type + "@" + mixedIntoType + "." + mixedIntoGroup }));
	  } else {
		  gvtList.push(new GVTModel({ group: item.apiVersion.split('/')[0], type: item.type }));
	  }

	    if (Array.isArray(item.children)) {
	        gvtList.push(...item.children.flatMap(child => this.extractGVTModels(child)));
	    }

	    return gvtList;
	}

	removeParamsQuery() {
	  const currentUrl = window.location.href;
	  const updatedUrl = currentUrl.replace(/([&?])params=[^&]*/, (match, prefix) => {
		  return prefix === '?' ? '?' : '';
	  });
	  window.history.replaceState({}, '', updatedUrl);

	}
	async setQueryUid() {
	    try {
	        const urlParams = await firstValueFrom(this.route.queryParamMap);
	        let params: any = urlParams.get('params');
	        const match = params?.match(/uid=([\w-]+)/);
	        if (match) {
	            this.queryUid = match[1];
	        }
	    } catch (error) {
	    }
	}

	onContentReady(policiesResult: RuleModel[]) {
	  //Group all policies by GroupType
	  policiesResult.forEach(policy => {
		  const delimiter = policy.type.includes('@') ? '@' : '/';
		  const [baseType] = policy.type.split(delimiter);
		  const gt = `${policy.group}-${baseType}`;
		  this.policiesMap[gt] = this.policiesMap[gt] || [];
		  this.policiesMap[gt].push(policy);
	  });

	  //Add policies to resources according to their GroupType
	  this.items.forEach((item) => {
		  this.addItemRules(item);
		  if (Array.isArray(item.children)) {
			  item.children.forEach((childItem) => this.addItemRules(childItem));
		  }
	  });
	  this.items = [...this.items];
	  this.dataTable.syncExpandedChildrenRows();
	}

	addItemRules(item: ResourceModel) {
	  const baseGroupType = "*-*";
	  if (!item.apiVersion) {
		  return;
	  }
	  const [group] = item.apiVersion.split('/');
	  const gt = `${group}-${item.type}`;
	  const genericGroup = `${group}-*`;
	  const genericType = `*-${item.type}`;
	  item.rules = this.policiesMap[gt] || [];
	  item.rules.push(...(this.policiesMap[genericGroup] || []));
	  item.rules.push(...(this.policiesMap[genericType] || []));

	  //If the 'base' GroupType exists, add its rules to the resource as well
	  if (this.policiesMap[baseGroupType]) {
		  item.rules.push(...this.policiesMap[baseGroupType]);
	  }
	}

	getService(resourceType: ResourceType): ResourceContentService<ResourceModel> {
	    switch (resourceType) {
	    case ResourceType.FOLDER:
	        return this._folderService;
	    case ResourceType.RESOURCE_GROUP:
	        return this._resourceGroupService;
	    case ResourceType.ORGANIZATION:
	        return this._organizationService;
	    default:
	        throw new Error('Service does not exist for given resource');
	    }
	}

	loadItems(): Observable<ResourceModel[]> {
	    super.closeFcl();
	    this.setLoading(true);
	    this.items = [];
	    const service = this.getService(this.currentType);

	    const resourcesObservable = service.getContent(this.fullPath).pipe(
	        takeUntil(this.forkReqSubject),
	        shareReplay(1)
	    );

	    resourcesObservable.subscribe({
	        next: (resourcesResult) => {
	            this.onGetListSuccess(resourcesResult);
	        },
	        error: this.onGetListError.bind(this),
	    }).add(() => (this.setLoading(false)));

	    return resourcesObservable;
	}


	loadPolicies(groupTypePairsList: Array<{ group: string; type: string }>) {
	  return this.resourceDataService.getPolicies(this.fullPath, groupTypePairsList);
	}

	onGetListError(err: Error) {
	    this.errorEvent.emit(err);
	    this.items = [];

	    this.eventService.emitPageLoadEvent('error');
	}

	onGetListSuccess(res: ResourceModel[]) {
	  this.addMixinContainer(res || []);
	    res?.forEach(async (r) => {
	        this._organizationHierarchyStore.addResource(this.organizationName, r);
	        if (this.isResourceInProcess(r.state)) {
	            this.pollWhileInProcess(r);
	        }
		  if (this.isResourceWhitingForDeletion(r)) {
			  r.markedForDeletion = true;
		  }
	        if (Utils.hasFeatureFlag(Const.FEATURE_MOVE_RESOURCE)) {
	            await this.processResourceMovement(r);
	        }
	    });

	    this.items = (res || []).sort(this.sortFn);
	    this.errorEvent.emit(null);
	    this.eventService.emitPageLoadEvent('success');
	}

	addMixinContainer(dataset: any[]): void {
	  for (let i = dataset.length - 1; i >= 0; i--) {
		  const item = dataset[i];
	        if (item.resource?.metadata?.mixedInto) {
	            const mixedIntoType = item.resource.metadata.mixedInto.type;
	            const matchingItems = dataset.filter(otherItem =>
	                otherItem.type === mixedIntoType && otherItem.name === item.name
	            );

			  let wasAdded = false;
	            matchingItems.forEach(matchingItem => {
	                if (!matchingItem.children) {
	                    matchingItem.children = [];
	                }
	                matchingItem.children.push(item);
				  wasAdded = true;

				  if (matchingItem.children.length > 1) {
					  matchingItem.children.sort(this.sortFn);
				  }
	            });

			  if (wasAdded) {
				  dataset.splice(i, 1);
			  }
	        }
	    }
	}

	async processResourceMovement(r: ResourceModel) {
	    const resourceMover = this.getResourceMover(r);

	    if (resourceMover?.operationID) {
	        r.moveInProcess = !!this.containerIsMoving || !!resourceMover.state;
		  r.moveFailed = false;

	        if (!this.containerIsMoving && resourceMover.state) {
	            const parentResource = await this.getResourceParent();
	            const parentResourceMover = this.getResourceMover(parentResource);

	            if (resourceMover.operationID === parentResourceMover?.operationID) {
	                this.containerIsMoving = true;
	                this.resourceContentIsMoving.emit(resourceMover.operationID);
	            } else {
	                this.pollWhileMoving(r);
	            }
	        } else if (await this.hasLastMoveFailedInTheLast30Days(r)) {
	            r.moveFailed = true;
	        }
	    }
	}

	async getMoveStatus(event: Event, r: ResourceModel) {
	  event.stopPropagation();
	  const resourceMover = this.getResourceMover(r);
	  const operationId = resourceMover?.operationID;
	  try {
		  const resourceStatus = await firstValueFrom(this.resourceDataService.getMoveStatus(operationId));
		  const data = {
			  operationId: operationId,
			  status: resourceStatus.status
		  };
		  this._dialogService.openDialog(MoveResourceStatueDialogComponent, data);
	  } catch (e) {
		  console.log("Could not get move resource status", e);
	  }
	}

	doUpdateResource(enrichedResource: ResourceModel) {
	    if (this.isResourceInProcess(enrichedResource.state)) {
	        this.pollWhileInProcess(enrichedResource);
	    }
	    this.updateResource(enrichedResource); //do it separately to avoid infinite LOOP!!!
	}

	updateResource(enrichedResource: ResourceModel) {
	    this.organizationHierarchyStore.updateResource(this.organizationName, enrichedResource);
	    const flatChildren = this.items.flatMap(item => item.children).filter(Boolean);
	    const allItems = [...this.items, ...flatChildren];
	    let item = allItems.find(
	        (item) => this.findSelectedRow(item, enrichedResource)
	    );
	    if (item) {
	        let {rules, customSubresources, ...rest} = enrichedResource;
	        Object.assign(item, rest);
	    }
	    this.items = [...this.items];

	    //Triggers change detection on content details

	    if (this.findSelectedRow(this.selectedRow, item)) {
	        this.selectedRow = Object.assign({}, item);
	    }
	    return item;
	}

	isResourceInProcess(state: ResourceState) {
	  return (
		  !state ||
		  state === ResourceState.IN_PROCESS ||
		  state === ResourceState.TERMINATING
	  );
	}

	isResourceWhitingForDeletion(resource: ResourceModel) {
	    return !!resource.resource?.metadata?.deletionTime;
	}

	async getResourceParent() {
	  let service = this.getService(this.currentType);
	  return firstValueFrom(service.get(this.fullPath)).then((r) => {
		  return r;
	  });
	}

	async hasLastMoveFailedInTheLast30Days(resource: ResourceModel) {
	  const resourceMover = this.getResourceMover(resource);
	  if (resource.path === resourceMover?.source || resourceMover.errors) {
		  try {
			  const resourceStatus = await firstValueFrom(this.resourceDataService.getMoveStatus(resourceMover.operationID));
			  return !this.isMoreThan30DaysPassed(resourceStatus?.status?.startTime);
		  } catch (e) {
			  return false;
		  }
	  }
	  return false;
	}

	isMoreThan30DaysPassed(startTime: string | undefined | null) {
	    if (!startTime) {
	        return false; // Handle undefined or null
	    }

	    const startDate = new Date(startTime);
	    const currentDate = new Date();

	    // Calculate the difference in time in milliseconds
	    const timeDifference = currentDate.getTime() - startDate.getTime();

	    // Convert the difference to days
	    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

	    // Check if the difference is greater than 30 days
	    return daysDifference >= 30;
	}

	getResourceMover(r: ResourceModel) {
	  return r?.resource.metadata.mover;
	}

	pollWhileExists(enrichedResource: ResourceModel) {
	    let fetchUrl = `/api/resources/${enrichedResource.apiVersion}/${enrichedResource.type}${enrichedResource.path}/${enrichedResource.name}`;
	    this.pollingService.addUrlPoolTask(fetchUrl, this.pool, (response: FetchResponse) => {
	        if (!response.ok) {
	            this.deleteResource(enrichedResource);
	            return true;
	        }
	        return false;
	    });
	}

	pollWhileMoving(enrichedResource: ResourceModel) {
	    let fetchUrl = `/api/resources/${enrichedResource.apiVersion}/${enrichedResource.type}${enrichedResource.path}/${enrichedResource.name}`;
	    this.pollingService.addUrlPoolTask(fetchUrl, this.pool, (response: FetchResponse) => {
	        if (!response.ok) {
	            this.deleteResource(enrichedResource);
	            return true;
	        } else if (!response.body.metadata.mover?.state) {
			  enrichedResource.moveInProcess = false;
			  return true;
		  }
	        return false;
	    });
	}

	pollWhileInProcess(enrichedResource: ResourceModel) {
	  let fetchUrl = `/api/resources/${enrichedResource.apiVersion}/${enrichedResource.type}${enrichedResource.path}/${enrichedResource.name}`;
	  const mixedIntoQueryString = this.getMixedIntoQueryString(enrichedResource);
	  if (mixedIntoQueryString) {
		  fetchUrl = `${fetchUrl}${mixedIntoQueryString}&returnType=model`;
	  } else {
		  fetchUrl = `${fetchUrl}?returnType=model`;
	  }
	  let noStatusCount = 0;
	  this.pollingService.addUrlPoolTask(fetchUrl, this.pool, (response: FetchResponse) => {
		  if (!response.ok) {
			  console.log('response from server was bad');
		  }
		  let resource = response.ok ? response.body : enrichedResource;
		  if (!resource.resource.status || !resource.resource.status.conditions.find((condition: any) => condition.type === "Ready")) {
			  noStatusCount++;
		  }

		  const setNoStatus = noStatusCount > this.MAX_POLLING_NO_STATUS;
		  this.updateResource(this._contentItemService.enrichItem(resource, setNoStatus));

		  if (setNoStatus) {
			  return true;
		  } else if (!resource.resource.status) {
			  return false;
		  }

		  let readyCondition = resource.resource.status.conditions.find((condition: any) => condition.type === "Ready") || {};
		  let statusTrue = (readyCondition.status || '').toLowerCase() === 'true';
		  return statusTrue && !this.isResourceInProcess(Utils.getState(resource, true));
	  });
	}

	createResource(enrichedResource: ResourceModel) {
	    if (this.isResourceInProcess(enrichedResource.state)) {
	        this.pollWhileInProcess(enrichedResource);
	    }
      	this.addItemRules(enrichedResource);
	    this.organizationHierarchyStore.addResource(this.organizationName, enrichedResource);
	    let exists = this.items.some(
	        (item) => this.findSelectedRow(item, enrichedResource)
	    );
	    if (!exists) {
	        this.items.push(enrichedResource);
	        this.items = [...this.items];
	    }
	    this.selectRow(enrichedResource, true);
	    this.dataTable.virtualScrollToRowByProp('uid', enrichedResource.uid);
	}

	deleteResource(deletedResource: ResourceModel) {
	    if (this.selectedRow?.name === deletedResource.name) {
	        this.closeFcl();
	    }
	    this.organizationHierarchyStore.removeResource(this.organizationName, deletedResource);
	    this.items = this.items.filter(
	        (resource) => !(this.findSelectedRow(resource, deletedResource))
	    );
	    this.items = [...this.items];
	}

	async getResourceDataByPath(resource: ResourceModel){
	  const path = resource?.path + "/" + resource?.name;
	  const content = this.resourceDataService.getResourcesInPath(path, "validateParent=false");
	  return await firstValueFrom(content);
	}

	isCascadeDeleteable(resource: ResourceModel) {
	  return Utils.isPathCascadeDeleteable(this.appConfigService.getCascadeDeleteRules(), resource) && this.isFolderCreatedByWizard(resource);
	}

	isFolderCreatedByWizard(resource: ResourceModel) {
	  const tags = resource?.resource?.metadata?.tags;
	  return (tags?.["helm-plugin.resource.api.sap/release-path"] == resource.path);
	}

	async getResourceContent(resource: ResourceModel){
	  try {
		  return await this.getResourceDataByPath(resource);
	  } catch (e) {
	        return [];
	  }
	}

	checkIfManagedServiceContainsResourcesError(error: any){
	  const errMessage = error?.message?.includes("Some of its resources are unavailable for deletion");
	  if (errMessage){
		  const pattern = /Cannot delete ([a-zA-Z0-9-_]+)/;
		  const match = error?.message.match(pattern);
		  if (match) {
			  return match[1];
		  }
	  }
	  return "";
	}


	async handleFolderCreatedByWizardDelete(resourceToDelete: ResourceModel, content: any) {
	  const managedServiceArray = content.filter((resource: ResourceModel) => resource.type === ResourceType.MANAGED_SERVICE);
	  const data: any = {
		  resource: resourceToDelete,
		  managedServiceArray: managedServiceArray
	  };


	  let dialogRef = this._dialogService.openDialog(DeleteFolderWithDataDialogComponent, data, undefined, "500px");
	  try {
		  await firstValueFrom(dialogRef.afterClosed);
	  } catch (e: any) {
		  if (e === "Cancel" || e === "escape") {
			  return;
		  }
		  const managedName = this.checkIfManagedServiceContainsResourcesError(e);
		  if (managedName !== ""){
			  const resource = managedServiceArray.find((res: any) => res.name === managedName);
			  this._dialogService.openDialog(HasResourcesDeletionFailedDialogComponent, {resource: resource}, undefined, "500px");
		  } else {
			  this._dialogService.openMessageBox("Delete Folder with Content Failed", e ,"error");
		  }
		  // Step out of Folder Cascade deletion flow
		  throw e?.message || e;
	  }

	  await firstValueFrom(this._folderService.delete(resourceToDelete.path, resourceToDelete.name, "?cascadeDelete=true"));
	  this.handlePollWhileExists(resourceToDelete);
	}

	async onDeleteResource(resourceToDelete: ResourceModel) {
	    this.uisService.sendUISEvent(this.uisService.UIS_EVENT_TYPES.OPEN_DELETE_RESOURCE + " - "
		+ resourceToDelete.type, {type: resourceToDelete.type, path: resourceToDelete.path});
	    this.swaService.sendCustomEvent(
	        this.swaService.SWA_EVENT_TYPES.OPEN_DELETE_RESOURCE,
	        [resourceToDelete.type],
	        []
	    );
	    let data: any = {
	        resource: resourceToDelete,
	    };
	    let content;

	    switch (resourceToDelete.type) {
	    case ResourceType.FOLDER:
		  content = await this.getResourceContent(resourceToDelete);
		  if(content.length > 0 && this.isCascadeDeleteable(resourceToDelete)) {
			  await this.handleFolderCreatedByWizardDelete(resourceToDelete, content);
			  return;
		  }
		  else if (content.length > 0) {
			  this.handleHasContentDelete(ResourceType.FOLDER);
			  return;
		  } else {
			  this.handleFolderDelete(data, resourceToDelete);
		  }

		  break;
	    case ResourceType.RESOURCE_GROUP:
	  	if ((await this.getResourceContent(resourceToDelete)).length > 0) {
	            this.handleHasContentDelete(ResourceType.RESOURCE_GROUP);
			  return;
	        } else {
	            this.handleResourceGroupDelete(data, resourceToDelete);
	  }
	        break;
	    default:
	        this.handleGenericDelete(data, resourceToDelete);
	        break;
	    }

	    let dialogRef = this._dialogService.openDialog(DeleteConfirmationDialogComponent, data);
	    dialogRef.afterClosed.subscribe({
	        next: (res) => {
	            this.handlePollWhileExists(res);
	        },
	    });
	}

	handlePollWhileExists(res: ResourceModel){
	  let resourceDeleting: ResourceModel = this.items.find((resource) => this.findSelectedRow(resource, res));
	  if (resourceDeleting) {
		  resourceDeleting.state = ResourceState.TERMINATING;
		  if (
			  this.findSelectedRow(this.selectedRow, resourceDeleting)
		  ) {
			  this.selectedRow = Object.assign({}, resourceDeleting);
		  }
		  this.pollWhileExists(resourceDeleting);
	  }
	}
	handleFolderDelete(data: any, resourceToDelete: ResourceModel, queryString = "") {
	    data['title'] = 'Delete Folder';
	    data.deleteFunc = () => {
	        return this._folderService.delete(resourceToDelete.path, resourceToDelete.name, queryString);
	    };
	}

	handleResourceGroupDelete(data: any, resourceToDelete: ResourceModel) {
	    data['title'] = 'Delete Resource Group';
	    data.deleteFunc = () => {
	        return this._resourceGroupService.delete(resourceToDelete.path, resourceToDelete.name);
	    };
	}

	handleGenericDelete(data: any, resourceToDelete: ResourceModel) {
	    data['title'] = 'Delete ' + resourceToDelete.typeDisplayName;
	    let path = resourceToDelete.path || '';
	    if (path === Const.ROOT_PATH) {
	        path = '';
	    }
	    let url = `/${resourceToDelete.apiVersion}/${resourceToDelete.type}/${path}`;
	    const queryString = this.getMixedIntoQueryString(resourceToDelete);

	    data.deleteFunc = () => {
	        return this.resourceDataService.delete(url, resourceToDelete.name, queryString);
	    };
	}

	sortFn(n1: ResourceModel, n2: ResourceModel) {
	    if (n1.displayName > n2.displayName) {
	        return 1;
	    }

	    if (n1.displayName < n2.displayName) {
	        return -1;
	    }

	    return 0;
	}

	async onEditResource(resource: ResourceModel, schema?: any, isExpanded = false) {
	  this.sessionProvider.validateSession();
	  let freshResource: ResourceModel;
	  try {
		  freshResource = await this.retrieveResource(resource);
	  } catch (e) {
		  freshResource = resource;
	  }

	  if (!freshResource) {
		  console.error('Unable to retrieve resource for editing');
		  return;
	  }

	  this.selectedRow = freshResource;
	    let dialogRef = this._dialogService.openSideDialog(
	        this.getDialogType(freshResource.type, !!schema),
	        {
	            resource: freshResource,
	            schema: schema,
	            isEdit: true,
			  isExpanded: isExpanded,
	        },
		  freshResource.type !== ResourceType.FOLDER && freshResource.type !== ResourceType.RESOURCE_GROUP ? '62.5rem' : undefined
	    );
	    dialogRef.afterClosed.subscribe({
	        next: (res) => {
	            this.doUpdateResource(res);

	            if(this.isFclClosed() || !this.findSelectedRow(this.selectedRow, res)) {
	                this.selectRow(res,true);
	            }
	            this.dataTable.virtualScrollToRowByProp('uid', res.uid);
	        },
	    });
	    this.setLoading(false);
	}

	onMoveResource(resourceToMove: ResourceModel) {
	  const moveDialogRef = this._dialogService.openDialog(MoveResourceDialogComponent, {resource: resourceToMove});
	  moveDialogRef.afterClosed.subscribe({
		  next: (moveDialogResult: any) => this.handleMoveDialogResult(moveDialogResult),
	  });
	}

	onAnalyzeFailure(resource: ResourceModel) {
	  this._aiAssistantService.open(this._aiAssistantService.buildResourceContext(resource));
	}

	handleMoveDialogResult(moveDialogResult: any): void {
	    const moveConfirmationDialogRef = this._dialogService.openDialog(MoveResourceConfirmationDialogComponent, moveDialogResult);
	    moveConfirmationDialogRef.afterClosed.subscribe({
	        next: (moveOperationPreflightResult: any) => this.handleMoveOperationPreflightResult(moveOperationPreflightResult),
	    });
	}

	handleMoveOperationPreflightResult(moveOperationPreflightResult: any): void {
	    if (moveOperationPreflightResult.preflightSucceeded) {
	        this.handleMoveOperationStarted(moveOperationPreflightResult.resource);
	    } else {
	        this._dialogService.openDialog(MoveFailedErrorMessageDialogComponent, moveOperationPreflightResult);
	    }
	}

	handleMoveOperationStarted(resource: ResourceModel) {
	  let resourceMoving: ResourceModel = this.items.find((r) => this.findSelectedRow(r, resource));
	  if (resourceMoving) {
		  resourceMoving.moveInProcess = true;
		  this.pollWhileMoving(resourceMoving);
	  }
	}


	onEditWithForm(resource: ResourceModel) {
	    this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.EDIT_RESOURCE_WITH_FORM, [resource.type], []);
	    if (
		  !this.showEditWithYaml(resource)
	    ) {

	        this.onEditResource(resource);
	    } else {
	        let url = `${resource.apiVersion}/${resource.type}${resource.path}/${resource.name}/.schema`;

	        this.setLoading(true);
	        this.resourceDataService.get(url).subscribe({
	            next: this.onEditResource.bind(this, resource),
	            error: this.onGetResourceSchemaError.bind(this),
	        });
	    }
	}

	async onReconcileResource(resource: ResourceModel) {
	  this.swaService.sendCustomEvent(this.swaService.SWA_EVENT_TYPES.RECONCILE_RESOURCE_CLICKED, [resource.type], []);
	  try {
		  this.notificationsService.showMessageToast('Reconciling the resource now. Monitor the status for an update.');
		  await firstValueFrom(this.resourceDataService.touch(resource.apiVersion, resource.type, resource.path, resource.name, resource));
		  resource.state = ResourceState.IN_PROCESS;
		  // Update the resource in the items array and trigger change detection
		  const updatedItem = this.updateResource(resource);
		  // Start polling until resource is no longer in process
		  this.pollWhileInProcess(resource);
		  if (this.isFclClosed() && updatedItem) {
			  this.toggleFcl(updatedItem);
		  }
	  } catch (e: Error | any) {
		  this._dialogService.openDialog(ReconcileFailedErrorMessageDialogComponent, {errorMsg: e.message});
	  }
	}

	async onReloadResource(resource: ResourceModel) {
	  try {
		  this.setLoading(true);
		  const freshResource = await this.retrieveResource(resource);
		  if (this.isFclClosed()) {
			  this.toggleFcl(freshResource);
		  } else {
			  this.selectedRow = freshResource;
		  }
	  } catch (e) {

	  } finally {
		  this.setLoading(false);
	  }
	}

	onGetResourceSchemaError(err: Error) {
	    this.error = err;
	    this.setLoading(false);
	}

	openCreateInstanceDialog(resource: ResourceModel) {
	    this.publish.emit(resource);
	}

	getDialogType(resourceType: string, editWithForm: boolean) {
	    switch (resourceType) {
	    case ResourceType.FOLDER: {
	        return CreateFolderDialogComponent;
	    }
	    case ResourceType.RESOURCE_GROUP: {
	        return CreateResourceGroupDialogComponent;
	    }
	    default:
	        return editWithForm ? CreateInstanceDialogComponent : CreateGenericResourceDialogComponent;
	    }
	}

	async retrieveResource (resource: ResourceModel) {
	  const query = this.getGetResourceQueryString(resource);
	  const url = `${resource.apiVersion}/${resource.type}${resource.path}/${resource.name}`;

	  const freshResource = await firstValueFrom(this.resourceDataService.get(url, query));
	  return this.updateResource(freshResource);
	}

	onApplyAdvancedFilters(filters: any) {
	    // Store the filters and trigger the resource content to load filtered data
	    this.currentAdvancedSearchFilters = filters;
	    filters.limit = Const.MAX_ADVANCED_FILTER_RESULTS;
	    this.loadFilteredContent(filters);
	}

	getNavigationRoute(row: ResourceModel): string[] | null {
	    if (!this.isNavigable(row.type)) {
	        return null;
	    }

	    if (this.advancedSearchOpen) {
	        // In advanced search mode, disable direct navigation
	        // Users should use "View in Organization Explorer" action instead
	        return null;
	    }

	    // Normal navigation for direct children
	    const routeSegment = row.type === ResourceType.FOLDER ? 'folders' : 'resource-groups';
	    return [(!this.currentPath ? './' : '../') + routeSegment];
	}

	getNavigationQueryParams(row: ResourceModel): any {
	    if (!this.isNavigable(row.type) || this.advancedSearchOpen) {
	        return null;
	    }

	    // Normal navigation for direct children
	    return {path: this.currentPath + '/' + row.name};
	}
}
